// images
import imgfirst from '../images/service/Earthing Solution_5_11zon.webp'
import img1 from '../images/service/cable tray.webp'
import img2 from '../images/service/DMC Insulator.webp'
import img3 from '../images/service/kihi-product3.webp'
import img4 from '../images/service/image4.webp'
import img5 from '../images/service/image5.webp'
import img6 from '../images/service/image6.webp'
import img7 from '../images/service/image 6.webp'
import img8 from '../images/service/image 7.webp'
import img9 from '../images/service/image 8.webp'
import img10 from '../images/service/image 9.webp'
import img11 from '../images/service/image11.webp'
import img12 from '../images/service/image12.webp'
import img13 from '../images/service/image13.webp'
import img14 from '../images/service/image14.webp'
import img15 from '../images/service/image15.webp'
import img16 from '../images/service/image16.webp'
import img17 from '../images/service/image17.webp'
import img18 from '../images/service/image18.webp'
import img19 from '../images/service/image19.webp'
import img20 from '../images/service/image20.webp'
import img21 from '../images/service/image21.webp'
import img22 from '../images/service/image22.webp'
import img23 from '../images/service/image23.webp'
import img24 from '../images/service/image24.webp'


/* Single image */
import simg1 from '../images/service-single/img-1.jpg'
import simg2 from '../images/service-single/img-2.jpg'
import simg3 from '../images/service-single/img-3.jpg'
import simg4 from '../images/service-single/img-4.jpg'

/* icon image */
import icon1 from '../images/service/icon-1.svg'
import icon2 from '../images/service/icon-2.svg'
import icon3 from '../images/service/icon-3.svg'
import icon4 from '../images/service/icon-4.svg'


const Services = [
    {
        id: 1,
        image: imgfirst,
        icon: icon1,
        simage: simg1,
        title: 'Earthing Solution',
        description: 'A cable tray is a structural system used to securely support and route electrical cables, wires, and communication lines in buildings and industrial facilities.',
        slug: 'cable-tray',
        leftFeatures: [
            "The Galvanization Of Iron Makes It A Corrosion-Resistant Electrode.",
            "The Current Dissipation Rate Is High.",
            "There Is No Need To Pour Water",
            "Weld Consistency And Integrity."
        ],
        rightFeatures: [
            "Periodical Moisturization Is Not Necessary.",
            "High Durability And Reliability.",
            "It Is Suitable For All Kinds Of Soil.",
            "GI Earthing Electrodes Is Designed For Fast Fault Current Dissipation"
        ],
        specificationsData: {
            specifications: [
                "Available in 50, 80, 88, & 100 m - 0.5, 1, 2, and 3 meters."
            ],
            applications: [
                "Electrical Industry",
                "Cements Industry",
                "Electrical Contractor",
                "Electrical Equipments",
                "Manufacturing Industries",
                "Sugar And Paper Industry",
                "Petrol & Chemical Industry"
            ],
            advantages: [
                "It Is Cheaper Than The Copper Electrode.",
                "Moisturization is less necessary.",
                "Requires Less Maintenance.",
                "Low impedance while grounding.",
                "Lesser Space Is Required.",
                "On-Site Easy And Fast Installation.",
                "The corrosion process is slower than that of a standard iron rod."
            ]
        }
    },
    {
        id: 2,
        image: img1,
        icon: icon1,
        simage: simg1,
        title: 'Cable Tray',
        description: 'A cable tray is a structural system used to securely support and route electrical cables, wires, and communication lines in buildings and industrial facilities.',
        slug: 'cable-tray',
        leftFeatures: [
            "The Galvanization Of Iron Makes It A Corrosion-Resistant Electrode.",
            "The Current Dissipation Rate Is High.",
            "There Is No Need To Pour Water",
            "Weld Consistency And Integrity."
        ],
        rightFeatures: [
            "Periodical Moisturization Is Not Necessary.",
            "High Durability And Reliability.",
            "It Is Suitable For All Kinds Of Soil.",
            "GI Earthing Electrodes Is Designed For Fast Fault Current Dissipation"
        ],
        specificationsData: {
            specifications: [
                "Available in 50, 80, 88, & 100 m - 0.5, 1, 2, and 3 meters."
            ],
            applications: [
                "Electrical Industry",
                "Cements Industry",
                "Electrical Contractor",
                "Electrical Equipments",
                "Manufacturing Industries",
                "Sugar And Paper Industry",
                "Petrol & Chemical Industry"
            ],
            advantages: [
                "It Is Cheaper Than The Copper Electrode.",
                "Moisturization is less necessary.",
                "Requires Less Maintenance.",
                "Low impedance while grounding.",
                "Lesser Space Is Required.",
                "On-Site Easy And Fast Installation.",
                "The corrosion process is slower than that of a standard iron rod."
            ]
        }
    },
    {
        id: 3,
        image: img2,
        icon: icon2,
        simage: simg2,
        title: 'DMC Insulator',
        description: 'A DMC insulator is a durable electrical component made from Dough Moulding Compound, used for insulating and supporting live parts in electrical systems.',
        slug: 'dmc-insulator',
        
        leftFeatures: [
            "Excellent electrical insulating properties.",
            "Suitable for both high and low voltage applications.",
            "High mechanical strength ensures durability under stress and load.",
            "Resistant to cracking or breaking under pressure."
        ],
        rightFeatures: [
            "Withstands high temperatures without deformation.",
            "Excellent thermal stability and heat resistance.",
            "Self-extinguishing and flame-retardant nature makes it safe for electrical environments.",
            "Performs well in humid or chemically aggressive environments."
        ],
        specificationsData: {
            specifications: [
                "High-strength, flame-retardant, moisture-resistant electrical components with excellent thermal and dielectric properties, suitable for up to 33kV applications."
            ],
            applications: [
                "Switchgear assemblies",
                "Busbar supports",
                "Circuit breakers ",
                "Metering equipment ",
                "Railway and automotive electrical systems.",
                "Renewable energy systems"
            ],
            advantages: [
                "Excellent electrical insulation",
                "High mechanical strength",
                "Flame-retardant",
                "Moisture and chemical resistant",
                "Dimensionally stable",
                "Cost-effective for mass production and long-term use."
            ]
        }
    },
    {
        id: 4,
        image: img3,
        icon: icon3,
        simage: simg3,
        title: 'Painting Contractor',
        description: 'Expert painting contractor specializing in residential, commercial, and industrial painting services with a focus on quality, precision, and timely project delivery.',
        slug: 'explore-tiling-and-painting',
        leftFeatures: [
            "Professional surface preparation ensures smooth and long-lasting results.",
            "Only high-quality, eco-friendly paints and materials are used.",
            "Expertise in both interior and exterior painting for all property types.",
            "Tailored solutions for residential, commercial, and industrial projects."
        ],
        rightFeatures: [
            "Comprehensive waterproofing and damp-proofing services available.",
            "Specialized in texture coating, stencil work, and decorative finishes.",
            "Strict adherence to project timelines for on-time delivery.",
            "All work handled by trained, experienced, and background-verified painters."
        ],
        specificationsData: {
            specifications: [
                "Painting contractor services include surface preparation, use of premium paints, multiple finish options, brush/roller/spray application, and timely, safe execution for residential, commercial, and industrial projects."
            ],
            applications: [
                "Electrical Industry",
                "Cements Industry",
                "Electrical Contractor",
                "Electrical Equipments",
                "Manufacturing Industries",
                "Sugar And Paper Industry",
                "Petrol & Chemical Industry"
            ],
            advantages: [
                "It Is Cheaper Than The Copper Electrode.",
                "Moisturization is less necessary.",
                "Requires Less Maintenance.",
                "Low impedance while grounding.",
                "Lesser Space Is Required.",
                "On-Site Easy And Fast Installation.",
                "The corrosion process is slower than that of a standard iron rod."
            ]
        }
    },
    {
        id: 5,
        image: img4,
        icon: icon4,
        simage: simg4,
        title: 'GI Earthing Electrodes',
        description: ' Durable and corrosion-resistant grounding solution made from galvanized iron for safe and efficient fault current dissipation..',
        slug: 'gi-earthing-electrodes',
        leftFeatures: [
            "High Conductivity: Provides efficient dissipation of fault and leakage currents.",
            "Galvanized Coating: Zinc coating ensures corrosion resistance and extended lifespan.",
            "Strong Build: Made from high-quality galvanized iron for durability in all soil conditions.",
            "Maintenance-Free: Requires little to no maintenance over time.",
            "Easy Installation: Lightweight and simple to install at any site.",
        ],
        rightFeatures: [
            "Long Life: Typical lifespan of 8-10 years depending on soil and usage.",
            "Low Earth Resistance: Ensures quick and effective earthing with minimal resistance.",
            "Environment Friendly: Non-polluting and safe for all types of installations.",
            "Available in Various Sizes: Customizable based on current capacity and site requirements.",
         "IS Standards Compliant: Designed as per industry and safety standards.",

        ],
        specificationsData: {
            specifications: [
                "Made from galvanized iron with 80-100 micron zinc coating, available in 1-3 meter lengths and 48-76 mm diameter, ensuring low earth resistance and long-lasting performance."
            ],
            applications: [
                "Residential Buildings",
                "Commercial Complexes",
                "Industrial Facilities ",
                "Telecommunication Towers ",
                "Electrical Substations",
                "Solar Power Plants",
                "Data Centers",
            ],
            advantages: [
                "Galvanized zinc coating protects against rust and extends lifespan.",
                "More affordable compared to copper electrodes while offering reliable performance.",
                "Requires little to no upkeep after installation.",
                "Lightweight and simple to set up in various soil types.",
                "Typically lasts 8–10 years in normal soil conditions.",
                "Provides low earth resistance for safe and fast fault current dissipation.",
                "Non-toxic and safe for soil and groundwater.",
            ]
        }
    },
    {
        id: 6,
        image: img5,
        icon: icon2,
        simage: simg2,
        title: 'Copper Bonded Earthing Electrodes',
        description: 'High-performance earthing solution made of low carbon steel with a copper-bonded coating, offering superior conductivity and corrosion resistance.',
        slug: 'copper-bonded-earthing-electrodes',
        leftFeatures: [
            "Excellent electrical conductivity due to pure copper bonding.",
            "Copper cladding resists oxidation and soil corrosion.",
            "Copper is molecularly bonded to steel for long-lasting durability.",
            "Ensures low earth resistance for effective fault current dissipation.",
            "Steel core provides mechanical strength and stability."
        ],
        rightFeatures: [
            "Typically lasts 15 to 20 years in most soil conditions.",
            "250–300 microns of copper coating for consistent performance.",
            "Requires no regular upkeep once installed.",
            "Manufactured as per national and international standards.",
            "Suitable for residential, commercial, industrial, and power systems."
        ],
        specificationsData: {
            specifications: [
                "Made from low carbon steel with 250–300 micron copper bonding, available in 1–3 meter lengths and 14.2–17.2 mm diameter, ensuring high conductivity and long service life."
            ],
            applications: [
                "Residential and Commercial Buildings",
                "Industrial Plants ",
                "Data Centers & IT Parks",
                "Telecommunication Towers ",
                "Electrical Substations",
                "Solar and Wind Power Systems",
                "Hospitals and Labs"
            ],
            advantages: [
                "Offers excellent electrical conductivity for efficient fault current dissipation.",
                "Copper bonding protects against corrosion even in harsh soil conditions.",
                "Typically lasts 15–20 years with minimal degradation.",
                "Steel core provides durability and resistance to bending or breaking.",
                "Ensures consistent performance with 250–300 micron copper layer.",
                "Once installed, requires little to no maintenance.",
                "Meets national and international safety and quality standards."
            ]
        }
    },
    {
        id: 7,
        image: img6,
        icon: icon2,
        simage: simg2,
        title: 'Pure Copper Earthing Electrodes',
        description: 'High-efficiency earthing solution made from solid pure copper, offering excellent conductivity, corrosion resistance, and long-lasting performance.',
        slug: 'pure-copper-earthing-electrodes',
        leftFeatures: [
            "Made of 99.9% pure electrolytic grade copper.",
            "Copper is naturally resistant to corrosion, especially in soil, ensuring a long life.",
            "Once installed, requires minimal or no maintenance over its lifespan.",
            "Capable of safely carrying high fault currents and lightning surges to the ground.",
            "Strong and robust; maintains shape and performance even in harsh environmental conditions."
        ],
        rightFeatures: [
            "Since the electrode is pure copper throughout, conductivity remains consistent over time.",
            "Non-toxic and recyclable, with minimal impact on soil and groundwater.",
            "Available in rod, pipe, or plate form for flexibility in installation depending on site conditions.",
            "Often manufactured in accordance with standards like IS 3043, IEEE 80, or IEC standards for grounding.",
            "Widely used in Power plant,Data center"
        ],
        specificationsData: {
            specifications: [
                "Made from 99.9% pure copper, available in 14.2–25 mm diameter and 1–3 meter lengths, offering exceptional conductivity and a lifespan of 25+ years."
            ],
            applications: [
                "Data Centers & IT Facilities ",
                "Hospitals & Laboratories",
                "Electrical Substations",
                "Telecommunication Towers",
                "Industrial Plants ",
                "Refineries & Petrochemical Units",
                "Banking & Financial Institutions"
            ],
            advantages: [
                "Offers the highest electrical conductivity among earthing materials.",
                "Ideal for aggressive and corrosive soil conditions.",
                "Provides 25+ years of reliable, maintenance-free performance.",
                "Ensures fast and effective dissipation of fault currents.",
                " Efficiently handles high fault and lightning currents.",
                "Non-toxic and safe for groundwater and soil.",
                "Meets international standards for safety and performance."
            ]
        }
    },
    {
        id: 8,
        image: img7,
        icon: icon2,
        simage: simg2,
        title: 'Ese Lightning Arrestors',
        description: 'ESE Lightning Arrestors are advanced devices designed to capture and safely divert lightning strikes before they hit a structure.',
        slug: 'ese-lightning-arrestors',
        leftFeatures: [
            "Proactively captures lightning before it strikes a structure.",
            "Covers large areas (up to 100 meters or more depending on model and height).",
            "Made of stainless steel or high-grade alloys for long life.",
            "No power supply or periodic servicing required."
        ],
        rightFeatures: [
            "Functions reliably in all climatic conditions.",
            "Emits upward streamer microseconds earlier than conventional systems.",
            "Compliant with IEC, NFC 17-102, and other international standards.",
            "Lightweight and compact, suitable for rooftops or towers."
        ],
        specificationsData: {
            specifications: [
                "Made of stainless steel with emission advance time of 10–60 μs, ESE lightning arrestors offer a protection radius of up to 107 meters and comply with NFC 17-102 and IEC standards."
            ],
            applications: [
                "Residential & Commercial Buildings",
                "Industrial Facilities",
                "Telecommunication Towers",
                "Hospitals & Educational Institutions ",
                "Airports & Railway Stations",
                "Oil & Gas Refineries",
                "Solar & Wind Farms"
            ],
            advantages: [
                "Covers large areas (up to 107 meters), reducing the number of arrestors needed.",
                "Activates microseconds earlier than conventional rods for better protection.",
                "No external power source or regular upkeep required.",
                "Made from corrosion-resistant materials like stainless steel for long life.",
                "Reduces infrastructure damage and insurance costs over time.",
                "Meets NFC 17-102, IEC, and IS guidelines",
                "Lightweight and compatible with existing building structures."
            ]
        }
    },
    {
        id: 9,
        image: img8,
        icon: icon2,
        simage: simg2,
        title: 'Pure Copper Solid Lighting-Arrestors',
        description: 'Pure Copper Solid Lightning Arrestors provide reliable and long-lasting protection against lightning strikes with superior conductivity and corrosion resistance.',
        slug: 'pure-copper-solid-lighting-arrestors',
        leftFeatures: [
            " Ensures excellent electrical conductivity.",
            "Ideal for coastal, industrial, and highly corrosive environments.",
            "Solid rod design offers strong mechanical strength and long life.",
            "Quickly directs lightning current safely to the ground.",
            "Requires no power source or regular servicing."
        ],
        rightFeatures: [
            "Copper is non-toxic, recyclable, and safe for soil and water in the long run.",
            "Simple mounting on rooftops, poles, or towers.",
            "40+ years of reliable performance.",
            "Meets IEC 62305, IS/IEC 62561, IEEE norms."
        ],
        specificationsData: {
             specifications: [
            "Material: Pure Copper",
            "Type: Solid Lightning Arrestor Rod",
            "Length: Available in 0.5m, 1m, 2m, and 3m",
            "Diameter: Standard sizes or customizable",
            "Installation: Rooftops, towers, poles",
            "Service Life: 40+ years"
        ],
        applications: [
            "Electrical Industry",
            "Cement Plants",
            "Power Distribution Systems",
            "Manufacturing Units",
            "Oil & Gas Refineries",
            "Sugar & Paper Industries",
            "Telecom Towers",
            "Residential & Commercial Buildings"
        ],
        advantages: [
            "Excellent corrosion resistance, ideal for coastal areas",
            "Low maintenance and long service life",
            "Fast and easy installation",
            "Environmentally friendly – copper is recyclable",
            "High mechanical strength",
            "Does not require external power source",
            "Provides quick dissipation of lightning current to ground"
        ]
    }
},
    {
        id: 10,
        image: img9,
        icon: icon2,
        simage: simg2,
        title: 'Copper Bonded Lightning Arrestor',
        description: 'Copper Bonded Lightning Arrestors provide superior grounding and over-voltage protection by combining the strength of steel with the conductivity of copper, ensuring enhanced performance and corrosion resistance in harsh environmental conditions.',
        slug: 'copper-bonded-lightning-arrestor',
    leftFeatures: [
        "Copper bonding ensures excellent conductivity and corrosion resistance.",
        "Ideal for rocky, dry, or high-resistance soil conditions.",
        "Uniform copper coating enhances lifespan and efficiency.",
        "Does not require regular watering or maintenance.",
        "Strong mechanical properties due to steel core."
    ],
    rightFeatures: [
        "Easy installation in all types of soil.",
        "Suitable for both residential and industrial applications.",
        "High fault current dissipation capacity.",
        "Designed as per IEEE, IS, and IEC standards.",
        "Eco-friendly and long-lasting material."
    ],
    specificationsData: {
        specifications: [
            "Material: Low Carbon Steel Core with Copper Bonding",
            "Copper Coating Thickness: Minimum 100 microns",
            "Length: Available in 1m, 2m, 3m",
            "Diameter: Standard sizes – 14.2mm, 17.2mm, 25mm",
            "Type: Earth Electrode for Lightning Protection",
            "Installation: Vertical mounting in soil/ground pits",
            "Service Life: 30+ years under standard conditions"
        ],
        applications: [
            "Electrical Power Systems",
            "Telecommunication Infrastructure",
            "Industrial Plants and Factories",
            "Oil & Gas Facilities",
            "Solar and Wind Energy Farms",
            "Commercial & Residential Buildings",
            "Data Centers",
            "Transportation and Rail Networks"
        ],
        advantages: [
            "Cost-effective alternative to solid copper rods",
            "Excellent resistance to oxidation and corrosion",
            "Long operational life with minimal maintenance",
            "Suitable for diverse soil conditions",
            "High tensile strength ensures safe handling and installation",
            "Efficient dissipation of lightning and fault currents",
            "Complies with international grounding standards"
        ]
    }
},

    {
    id: 11,
    image: img10,
    icon: icon2,
    simage: simg2,
    title: 'Copper Hollow Lightning Arrestors With Base Plates',
    description: 'Copper Hollow Lightning Arrestors with Base Plates are engineered for efficient lightning protection. Featuring a hollow copper design and a sturdy base plate, they offer high conductivity, easy installation, and long-lasting performance in diverse environmental conditions.',
    slug: 'copper-hollow-lightning-arrestors-with-base-plates',
    leftFeatures: [
        "Lightweight hollow copper design for easy handling and installation.",
        "Base plate ensures firm mounting on rooftops or towers.",
        "Corrosion-resistant material for extended outdoor durability.",
        "Efficient discharge of lightning current to ground.",
        "No need for external power supply or frequent servicing."
    ],
    rightFeatures: [
        "Suitable for all types of soil and weather conditions.",
        "High conductivity for faster current dissipation.",
        "Conforms to IEC 62305 and IS/IEC 62561 safety standards.",
        "Ideal for industrial, commercial, and residential structures.",
        "Made from recyclable, eco-friendly copper materials."
    ],
    specificationsData: {
        specifications: [
            "Material: High-conductivity Hollow Copper Rod",
            "Design: Integrated with Base Plate for Secure Installation",
            "Length: Available in 0.5m, 1m, 2m, and 3m",
            "Outer Diameter: Customizable as per requirement",
            "Installation: Rooftop, Pole, or Elevated Structures",
            "Standards: IEC 62305, IS/IEC 62561 Compliant",
            "Service Life: 30+ Years in Normal Conditions"
        ],
        applications: [
            "Electrical Substations",
            "Telecommunication Towers",
            "Commercial Complexes",
            "Manufacturing Plants",
            "Renewable Energy Installations (Solar/Wind)",
            "Residential Buildings",
            "Oil & Gas Refineries",
            "Educational and Institutional Buildings"
        ],
        advantages: [
            "Lighter and easier to install than solid copper rods",
            "Secure base plate ensures stability in elevated installations",
            "Resistant to corrosion in harsh climates",
            "Minimal maintenance required over lifetime",
            "Efficient lightning current dissipation",
            "Long service life and high reliability",
            "Environmentally friendly and recyclable material"
        ]
    }
}
,
    {
    id: 12,
    image: img11,
    icon: icon2,
    simage: simg2,
    title: 'Square Earth Pit Covers',
    description: 'Square Earth Pit Covers are durable enclosures used to protect and provide access to earth pits and ground terminations. Designed for long-term use, they prevent tampering, environmental damage, and ensure safety in grounding systems.',
    slug: 'square-earth-pit-covers',
    leftFeatures: [
        "Robust and weatherproof construction.",
        "Ensures safety by covering live earthing components.",
        "Provides easy access for periodic testing and maintenance.",
        "Non-corrosive and resistant to chemical exposure.",
        "Lightweight and easy to install on site."
    ],
    rightFeatures: [
        "Available in various load-bearing capacities: light, medium, heavy-duty.",
        "Lockable covers for added security in public or industrial areas.",
        "UV-resistant and designed for outdoor use.",
        "Complies with IS and IEC earthing safety standards.",
        "Can be installed in concrete, paver blocks, or bare ground."
    ],
    specificationsData: {
        specifications: [
            "Material: Polypropylene / FRP / RCC (based on model)",
            "Shape: Square",
            "Sizes: 300x300 mm, 450x450 mm, 600x600 mm (custom sizes on request)",
            "Load Capacity: Light Duty, Medium Duty, Heavy Duty",
            "Color Options: Black / Grey / Green",
            "Features: Slip-resistant top, lifting hooks, lockable lid (optional)"
        ],
        applications: [
            "Electrical Substations",
            "Industrial and Commercial Complexes",
            "Telecommunication Towers",
            "Power Plants",
            "Renewable Energy Installations",
            "Underground Cable Termination Access",
            "Residential Buildings",
            "Data Centers"
        ],
        advantages: [
            "Protects earthing system from damage and tampering",
            "Prevents ingress of dust, water, and foreign material",
            "Long-lasting and maintenance-free design",
            "Provides safe and easy inspection access",
            "Resistant to rust, UV rays, and chemical corrosion",
            "Customizable size and strength for project-specific needs",
            "Sustainable and recyclable material options available"
        ]
    }
}
,
    {
    id: 13,
    image: img12,
    icon: icon2,
    simage: simg2,
    title: 'Round Earth Pit Covers',
    description: 'Round Earth Pit Covers are used to safely cover and protect earth pits, providing access for inspection and maintenance of grounding systems. Designed to withstand harsh weather, they offer durability, safety, and ease of installation.',
    slug: 'round-earth-pit-covers',
    leftFeatures: [
        "Manufactured from heavy-duty polypropylene or concrete materials.",
        "Provides secure coverage for ground inspection pits.",
        "UV stabilized and corrosion-resistant for long-term outdoor use.",
        "Lightweight structure allows quick installation.",
        "Perfect for use in pedestrian and vehicular areas."
    ],
    rightFeatures: [
        "Round shape allows better centering over pit installations.",
        "Non-slip surface design enhances safety.",
        "Comes with lifting slots for easy removal and inspection.",
        "Compatible with all types of earthing systems.",
        "Complies with IS and IEC standards for earthing safety."
    ],
    specificationsData: {
        specifications: [
            "Material: Polypropylene / FRP / RCC",
            "Shape: Round",
            "Sizes: 260mm, 300mm, 350mm, 450mm diameter",
            "Load Capacity: Light, Medium, Heavy-duty (based on model)",
            "Color Options: Black, Green, Grey",
            "Features: Slip-resistant top, lifting handle slots"
        ],
        applications: [
            "Earthing Systems for Commercial Complexes",
            "Telecommunication Towers",
            "Electric Power Distribution",
            "Solar & Wind Energy Farms",
            "Substations and Industrial Plants",
            "Oil & Gas Installations",
            "Data Centers and IT Parks",
            "Public Infrastructure Projects"
        ],
        advantages: [
            "Protects internal earthing components from damage and debris",
            "Weatherproof and resistant to UV radiation",
            "Easy to lift for periodic inspection and maintenance",
            "Durable and long service life with low maintenance",
            "Prevents accidental contact with exposed earth electrodes",
            "Lightweight yet strong material construction",
            "Eco-friendly and recyclable materials"
        ]
    }
}
,
    {
    id: 14,
    image: img13,
    icon: icon2,
    simage: simg2,
    title: 'Silver Back Fill Compounds',
    description: 'Silver Back Fill Compounds are high-conductivity, moisture-retaining materials used to improve the performance of earthing systems. They reduce soil resistivity, prevent corrosion, and ensure consistent grounding effectiveness over time.',
    slug: 'silver-back-fill-compounds',
    leftFeatures: [
        "Enhances conductivity between the electrode and soil.",
        "Maintains moisture to improve grounding efficiency.",
        "Prevents corrosion of earthing electrodes.",
        "Environmentally safe and non-toxic formulation.",
        "Performs well in all soil conditions including rocky or dry areas."
    ],
    rightFeatures: [
        "Reduces soil resistivity and improves grounding system performance.",
        "Does not leach or wash away with water over time.",
        "Requires no periodic recharging or maintenance.",
        "Improves fault current dissipation speed.",
        "Increases life of the overall earthing system."
    ],
    specificationsData: {
        specifications: [
            "Material Type: Chemically stable back fill compound",
            "Appearance: Fine granular / powder form",
            "Resistivity: <0.12 ohm-m when mixed with water",
            "Moisture Retention: High (hygroscopic nature)",
            "Application: Mixed and poured around the earthing electrode",
            "Packaging: 25 kg & 50 kg HDPE bags"
        ],
        applications: [
            "Electrical Substations",
            "Transmission & Distribution Lines",
            "Industrial Earthing Systems",
            "Solar and Wind Power Plants",
            "Telecommunication Towers",
            "Data Centers and IT Infrastructure",
            "Oil & Gas Refineries",
            "Commercial & Residential Complexes"
        ],
        advantages: [
            "Improves efficiency of grounding even in high resistivity soil",
            "Prevents corrosion of earthing rods and conductors",
            "No maintenance or re-application required",
            "Stable performance for 25+ years",
            "Reduces the footprint of the grounding system",
            "Eco-friendly and complies with safety regulations",
            "Increases the overall reliability of electrical protection systems"
        ]
    }
}
,
    {
    id: 15,
    image: img14,
    icon: icon2,
    simage: simg2,
    title: 'GI Strips',
    description: 'GI (Galvanized Iron) Strips are essential components used in earthing and lightning protection systems. They offer excellent conductivity, corrosion resistance, and mechanical strength, making them ideal for safe electrical grounding.',
    slug: 'gi-strips',
    leftFeatures: [
        "Hot-dip galvanized for enhanced corrosion resistance.",
        "Ensures safe dissipation of fault and leakage current.",
        "Uniform thickness and flat surface for consistent performance.",
        "High tensile strength for mechanical stability.",
        "Easy to weld and install across varied applications."
    ],
    rightFeatures: [
        "Ideal for earthing, bonding, and lightning protection.",
        "Suitable for industrial, commercial, and residential grounding systems.",
        "Compatible with all types of soil.",
        "Requires minimal maintenance after installation.",
        "Available in various sizes and thicknesses as per project needs."
    ],
    specificationsData: {
        specifications: [
            "Material: Hot-Dip Galvanized Iron (GI)",
            "Width: 20mm to 50mm",
            "Thickness: 3mm to 6mm",
            "Standard Lengths: 3 meters or customizable",
            "Coating Thickness: Minimum 80 microns",
            "Conforming Standards: IS 2629, IS 4759, BS EN ISO 1461"
        ],
        applications: [
            "Electrical Grounding Systems",
            "Lightning Protection Installations",
            "Telecommunication Infrastructure",
            "Substations and Power Plants",
            "Industrial Machinery Bonding",
            "Solar and Renewable Energy Systems",
            "Data Centers and IT Installations"
        ],
        advantages: [
            "Cost-effective alternative to copper strips",
            "High corrosion resistance and durability",
            "Excellent electrical conductivity",
            "Low maintenance and long operational life",
            "Strong mechanical integrity under stress",
            "Flexible sizing for different grounding designs",
            "Easy to fabricate, cut, and weld on-site"
        ]
    }
}
,
    {
    id: 16,
    image: img15,
    icon: icon2,
    simage: simg2,
    title: 'Copper Strips',
    description: 'Copper Strips are highly conductive, corrosion-resistant components used in earthing systems, lightning protection, and electrical bonding. Their superior performance makes them essential for safe and efficient electrical installations in critical infrastructure.',
    slug: 'copper-strips',
    leftFeatures: [
        "Excellent electrical conductivity for minimal resistance.",
        "Naturally corrosion-resistant and durable.",
        "Highly flexible and easy to bend, shape, or install.",
        "Stable under high fault current conditions.",
        "Provides long-lasting performance in harsh environments."
    ],
    rightFeatures: [
        "Ideal for earthing, bonding, and surge protection.",
        "Performs well in all soil types including saline and moist areas.",
        "Zero maintenance and long operational life.",
        "Meets IS, IEC, and IEEE standards for grounding systems.",
        "Can be easily soldered, welded, or mechanically joined."
    ],
    specificationsData: {
        specifications: [
            "Material: Pure Copper (EC Grade or Electrolytic)",
            "Width: 20mm to 50mm (customizable)",
            "Thickness: 3mm to 6mm",
            "Length: Standard 3 meters or as per requirement",
            "Conductivity: ≥ 98% IACS",
            "Standards: IS 1897, IEC 62561-2, ASTM B152"
        ],
        applications: [
            "Electrical Grounding Systems",
            "Power Transmission & Distribution",
            "Telecom Infrastructure",
            "Oil & Gas Facilities",
            "Data Centers and IT Parks",
            "Lightning Protection Systems",
            "Industrial and Commercial Buildings",
            "Renewable Energy Projects (Solar/Wind)"
        ],
        advantages: [
            "Superior conductivity ensures fast fault current dissipation",
            "Highly durable with no risk of rust or decay",
            "Works effectively in corrosive and damp environments",
            "Long service life (40+ years)",
            "No additional maintenance or moisturization required",
            "Easily fabricated and joined for custom installations",
            "Complies with global grounding and bonding standards"
        ]
    }
}
,
    {
    id: 17,
    image: img16,
    icon: icon2,
    simage: simg2,
    title: 'Copper Earthing Plates',
    description: 'Copper Earthing Plates are flat conductors used in earthing systems to ensure low-resistance grounding and safe fault current dissipation. They are highly durable, corrosion-resistant, and ideal for long-term grounding in critical installations.',
    slug: 'copper-earthing-plates',
    leftFeatures: [
        "Made from high-purity electrolytic copper.",
        "Provides a large surface area for better conductivity with soil.",
        "Highly resistant to corrosion even in acidic and saline environments.",
        "Ensures effective dissipation of fault and lightning currents.",
        "Easy to install with mechanical clamps or welding."
    ],
    rightFeatures: [
        "Long service life with minimal degradation.",
        "Suitable for all soil conditions, including coastal and marshy areas.",
        "Requires no recharging or periodic treatment.",
        "Complies with IS 3043 and international earthing standards.",
        "Can be customized in various thicknesses and sizes."
    ],
    specificationsData: {
        specifications: [
            "Material: Pure Electrolytic Copper",
            "Standard Sizes: 600mm x 600mm, 900mm x 900mm, 1000mm x 1000mm",
            "Thickness: 3mm to 6mm or as per requirement",
            "Conductivity: ≥ 98% IACS",
            "Standards: IS 3043, IEC 62561-2",
            "Finish: Natural / Bright Copper"
        ],
        applications: [
            "Electrical Grounding in Substations",
            "Telecommunication and Data Centers",
            "Power Generation and Distribution Plants",
            "Oil & Gas Facilities",
            "Solar and Wind Power Installations",
            "Industrial and Commercial Complexes",
            "Hospitals and Sensitive Equipment Zones",
            "Lightning Protection Systems"
        ],
        advantages: [
            "Excellent conductivity and high fault current capacity",
            "Corrosion-resistant and suitable for harsh environments",
            "Extended lifespan with zero maintenance",
            "Efficient grounding for safety of electrical systems",
            "Reduces earth resistance significantly",
            "Simple and fast to install",
            "Environmentally friendly – fully recyclable material"
        ]
    }
}
,
    {
    id: 18,
    image: img17,
    icon: icon2,
    simage: simg2,
    title: 'GI Plates',
    description: 'GI (Galvanized Iron) Plates are used in earthing systems to provide a safe and low-resistance path to the ground. These plates are durable, corrosion-resistant, and suitable for various industrial and commercial electrical grounding applications.',
    slug: 'gi-plates',
    leftFeatures: [
        "Hot-dip galvanized for long-lasting corrosion protection.",
        "Provides large surface contact with soil for effective grounding.",
        "High mechanical strength and structural stability.",
        "Performs reliably in dry and rocky soil conditions.",
        "Suitable for both vertical and horizontal earthing."
    ],
    rightFeatures: [
        "Cost-effective alternative to copper earthing plates.",
        "Easy to handle and install at site.",
        "Works well in all types of soils including saline and alkaline.",
        "Requires minimal maintenance post installation.",
        "Conforms to IS 3043 and IEC standards for earthing systems."
    ],
    specificationsData: {
        specifications: [
            "Material: Galvanized Iron (GI)",
            "Standard Sizes: 600mm x 600mm, 900mm x 900mm, 1000mm x 1000mm",
            "Thickness: 3mm to 6mm",
            "Galvanization: Minimum 80 microns (Hot-Dip)",
            "Finish: Zinc-coated surface",
            "Standards: IS 3043, ASTM A123, IEC 62561-2"
        ],
        applications: [
            "Power Substations and Distribution Networks",
            "Electrical Panels and Transformers",
            "Manufacturing and Processing Plants",
            "Telecommunication and Data Centers",
            "Commercial and Residential Buildings",
            "Cement and Steel Industries",
            "Renewable Energy Projects (Solar, Wind)",
            "Oil & Gas Facilities"
        ],
        advantages: [
            "High durability and resistance to rust and corrosion",
            "Provides effective fault current dissipation",
            "Easy to install and integrate into existing grounding systems",
            "Economical choice for mass installations",
            "Long service life with minimal maintenance",
            "Safe and reliable grounding for sensitive electrical systems",
            "Environmentally safe and compliant with standards"
        ]
    }
}
,
    {
    id: 19,
    image: img18,
    icon: icon2,
    simage: simg2,
    title: 'Exothermic Welding',
    description: 'Exothermic Welding is a high-quality metal joining process that creates a molecular bond between conductors, ensuring permanent, corrosion-resistant, and highly conductive electrical connections — ideal for grounding and lightning protection systems.',
    slug: 'exothermic-welding',
    leftFeatures: [
        "Produces a molecular bond that is superior to mechanical connections.",
        "No external power source is required for the welding process.",
        "Extremely low electrical resistance for efficient current flow.",
        "Corrosion-resistant and durable in harsh environments.",
        "Forms a permanent and maintenance-free joint."
    ],
    rightFeatures: [
        "Compact and portable – suitable for remote or on-site use.",
        "Withstands repeated electrical faults without degradation.",
        "Eliminates need for torque tools or tightening.",
        "Can be used for copper-to-copper, copper-to-steel, or steel-to-steel bonding.",
        "Conforms to IEEE, UL, and IEC earthing system standards."
    ],
    specificationsData: {
        specifications: [
            "Process Type: Thermite-based Exothermic Reaction",
            "Applicable Materials: Copper, Steel, Galvanized Steel",
            "Connection Types: Cable-to-cable, Cable-to-rod, Rod-to-plate, etc.",
            "Mold Material: Graphite (Reusable)",
            "Weld Powder Sizes: 45g, 65g, 90g, 115g (based on conductor size)",
            "Standards: IEEE Std 837, UL 467, IEC 62561-1"
        ],
        applications: [
            "Lightning Protection Systems",
            "Electrical Grounding Systems",
            "Telecom Tower Installations",
            "Substations and Power Plants",
            "Oil & Gas Installations",
            "Railway Electrification",
            "Renewable Energy Plants",
            "Data Centers and Critical Infrastructure"
        ],
        advantages: [
            "Superior electrical and mechanical connection",
            "No loosening or corrosion over time",
            "Permanent bond with zero maintenance",
            "Portable and safe for field applications",
            "Performs well under repeated electrical faults",
            "Reduces system impedance significantly",
            "Compliant with global safety and grounding standards"
        ]
    }
}
,
//     {
//     id: 20,
//     image: img19,
//     icon: icon2,
//     simage: simg2,
//     title: 'Petroleum Production',
//     description: 'Petroleum production involves the extraction, processing, and transportation of crude oil and natural gas. It requires advanced infrastructure and safety systems to ensure efficient output and minimal environmental impact in upstream and midstream operations.',
//     slug: 'petroleum-production-2',
//     leftFeatures: [
//         "Efficient drilling and extraction technologies for increased output.",
//         "Real-time monitoring systems for pressure, flow, and equipment health.",
//         "High-strength pipelines and storage systems for secure transport.",
//         "Corrosion-resistant materials to handle harsh environments.",
//         "Automated safety shutdown systems integrated across all stages."
//     ],
//     rightFeatures: [
//         "Compliant with global safety and environmental regulations.",
//         "Capable of operating in offshore, desert, and arctic conditions.",
//         "Use of enhanced oil recovery (EOR) techniques for extended field life.",
//         "Supports both onshore and offshore production facilities.",
//         "Integrated data systems for production analytics and decision-making."
//     ],
//     specificationsData: {
//         specifications: [
//             "Extraction Techniques: Primary, Secondary & Enhanced Oil Recovery (EOR)",
//             "Key Components: Wellheads, Pumps, Separators, Pipelines",
//             "Monitoring: SCADA, DCS, IoT-enabled sensors",
//             "Standards: API, ISO 14001, OSHA, IECEx for hazardous zones",
//             "Facility Types: Onshore rigs, Offshore platforms, FPSOs"
//         ],
//         applications: [
//             "Oil Fields & Exploration Sites",
//             "Offshore Drilling Rigs",
//             "Petrochemical Refineries",
//             "Gas Processing Facilities",
//             "Crude Oil Terminals",
//             "Storage and Tank Farms",
//             "Pipeline Transportation Networks"
//         ],
//         advantages: [
//             "Maximizes hydrocarbon recovery from reservoirs",
//             "Improved safety and automation reduce operational risk",
//             "Energy-efficient systems for sustainable extraction",
//             "Enables remote diagnostics and predictive maintenance",
//             "Complies with global petroleum production standards",
//             "Robust infrastructure for high-pressure and high-temperature conditions",
//             "Supports long-term, continuous production cycles"
//         ]
//     }
// }
,
    {
    id: 21,
    image: img20,
    icon: icon2,
    simage: simg2,
    title: 'Perforated Cable Tray',
    description: 'Perforated Cable Trays are ideal for routing, supporting, and protecting power and control cables in electrical installations. Designed with ventilation holes to enhance airflow, they reduce heat buildup and are widely used in commercial and industrial settings.',
    slug: 'perforated-cable-tray',
    leftFeatures: [
        "Engineered with precision-perforated slots for optimal cable ventilation.",
        "Supports heavy cable loads while maintaining structural strength.",
        "Easy cable exit and entry through pre-cut holes.",
        "Rust-resistant coatings (GI, powder-coated, or painted).",
        "Ideal for horizontal and vertical cable management."
    ],
    rightFeatures: [
        "Available in various widths, heights, and thicknesses.",
        "Lightweight yet robust design simplifies installation.",
        "Suitable for both indoor and outdoor environments.",
        "Compatible with accessories like bends, reducers, tees, and covers.",
        "Meets IS/IEC standards for cable management systems."
    ],
    specificationsData: {
        specifications: [
            "Material: Mild Steel / GI / Aluminum / SS",
            "Finish: Hot-Dip Galvanized / Powder Coated / Painted",
            "Width: 50mm to 1000mm",
            "Height: 25mm to 150mm",
            "Thickness: 1.2mm to 3mm",
            "Length: Standard 2.5 meters or customizable",
            "Accessories: Bends, Tees, Crosses, Reducers, Clamps, Covers"
        ],
        applications: [
            "Commercial Electrical Installations",
            "Industrial Automation Systems",
            "Data Centers and IT Infrastructure",
            "Power Plants and Substations",
            "Hospitals and Public Buildings",
            "Manufacturing and Assembly Units",
            "Telecom and Broadcasting Equipment",
            "Infrastructure Projects (Rail/Metro/Airports)"
        ],
        advantages: [
            "Allows natural cable cooling with ventilation design",
            "Reduces risk of cable insulation damage due to overheating",
            "Simplifies maintenance and cable routing",
            "Multiple material and coating options for various environments",
            "Strong load-bearing capacity with minimal sagging",
            "Quick and secure installation with bolt-on accessories",
            "Long-lasting performance with minimal maintenance"
        ]
    }
}
,
    {
    id: 22,
    image: img21,
    icon: icon2,
    simage: simg2,
    title: 'Ladder Type Cable Tray',
    description: 'Ladder Type Cable Trays are designed to support heavy-duty power and control cable installations over long spans. Their robust structure with rungs at regular intervals ensures excellent ventilation and load support, making them ideal for industrial environments.',
    slug: 'ladder-type-cable-tray',
    leftFeatures: [
        "Open ladder design ensures maximum airflow and heat dissipation.",
        "High load-carrying capacity suitable for heavy-duty applications.",
        "Available in multiple finishes – hot-dip galvanized, powder-coated, or painted.",
        "Strong side rails and welded rungs enhance mechanical strength.",
        "Supports both horizontal and vertical installations."
    ],
    rightFeatures: [
        "Quick and flexible cable installation or removal.",
        "Corrosion-resistant material for long-term use.",
        "Compatible with wide range of accessories and fittings.",
        "Customizable lengths, widths, and rung spacing available.",
        "Conforms to IS, NEMA, and IEC cable management standards."
    ],
    specificationsData: {
        specifications: [
            "Material: Mild Steel / Aluminum / Stainless Steel",
            "Finish: Hot-Dip Galvanized / Powder Coated / Painted",
            "Width: 150mm to 1000mm",
            "Height: 50mm to 150mm",
            "Rung Spacing: 250mm (standard) or customized",
            "Thickness: 1.6mm to 3mm",
            "Length: 2.5 meters (standard) or custom"
        ],
        applications: [
            "Power Plants and Utility Stations",
            "Manufacturing and Processing Industries",
            "Oil & Gas Installations",
            "Large Commercial Complexes",
            "Data Centers and Communication Hubs",
            "Transport Infrastructure (Rail/Metro/Airports)",
            "Chemical and Fertilizer Industries"
        ],
        advantages: [
            "Superior structural strength for heavy cable loads",
            "Efficient heat dissipation extends cable life",
            "Fast installation reduces labor costs",
            "Adaptable to different layouts with available accessories",
            "Low maintenance and long service life",
            "Ideal for long-span support with minimal sagging",
            "Ensures safe and organized cable management"
        ]
    }
}
,
    {
    id: 23,
    image: img22,
    icon: icon2,
    simage: simg2,
    title: 'Cable Tray Cover',
    description: 'Cable Tray Covers are used to protect cables laid in perforated or ladder-type cable trays from dust, moisture, falling objects, and mechanical damage. They provide a neat and secure covering to ensure the long-term safety and performance of cable installations.',
    slug: 'cable-tray-cover',
    leftFeatures: [
        "Protects cables from dust, debris, and moisture.",
        "Designed to fit standard perforated and ladder-type trays.",
        "Improves the lifespan of the cable system.",
        "Simple installation and removal for maintenance access.",
        "Prevents accidental contact with live cables."
    ],
    rightFeatures: [
        "Available in galvanized, painted, and powder-coated finishes.",
        "Corrosion and weather resistant for indoor/outdoor use.",
        "Customizable in width, length, and thickness.",
        "Can be ventilated or solid as per application.",
        "Meets industry cable management standards (IS/IEC/NEMA)."
    ],
    specificationsData: {
        specifications: [
            "Material: GI / Mild Steel / Aluminum / SS",
            "Finish: Hot-Dip Galvanized / Powder Coated / Painted",
            "Type: Solid / Ventilated",
            "Width: Matches tray size (50mm to 1000mm)",
            "Length: Standard 2.5 meters or custom length",
            "Thickness: 1.2mm to 2.5mm"
        ],
        applications: [
            "Electrical Control Panels",
            "Industrial Manufacturing Facilities",
            "Commercial Buildings and IT Parks",
            "Power Plants and Substations",
            "Hospitals and Data Centers",
            "Oil & Gas and Petrochemical Sites",
            "Transport Infrastructure"
        ],
        advantages: [
            "Shields cables from mechanical and environmental damage",
            "Enhances safety by preventing accidental contact",
            "Supports clean and organized cable layout",
            "Extends life of cable systems by protecting insulation",
            "Available in different finishes for corrosion resistance",
            "Quick installation over existing cable trays",
            "Ideal for both indoor and outdoor setups"
        ]
    }
}
,
    {
    id: 24,
    image: img23,
    icon: icon2,
    simage: simg2,
    title: 'Cable Tray Accessories',
    description: 'Cable Tray Accessories include bends, tees, reducers, clamps, couplers, and supports that facilitate the installation, extension, and routing of cable trays. These components help build a flexible and efficient cable management system in various industrial and commercial applications.',
    slug: 'cable-tray-accessories',
    leftFeatures: [
        "Allows seamless turns, elevation changes, and junctions in cable layouts.",
        "Improves tray alignment and connectivity across segments.",
        "Provides strong support and structural stability.",
        "Compatible with both ladder and perforated tray systems.",
        "Ensures quick and secure installation."
    ],
    rightFeatures: [
        "Available in various sizes, shapes, and finishes.",
        "Pre-drilled holes for easy assembly and bolting.",
        "Galvanized or powder-coated for corrosion protection.",
        "Custom accessories available for unique layouts.",
        "Compliant with IS and IEC cable routing standards."
    ],
    specificationsData: {
        specifications: [
            "Types: Horizontal bends, Vertical bends, Tees, Crosses, Reducers, Clamps, Covers, Couplers, Brackets",
            "Material: Mild Steel / GI / Aluminum / SS",
            "Finish: Hot-Dip Galvanized / Powder Coated / Painted",
            "Sizes: Compatible with tray widths from 50mm to 1000mm",
            "Mounting: Wall, ceiling, or floor supported"
        ],
        applications: [
            "Industrial Cable Management Systems",
            "Control Panels and Power Plants",
            "IT and Server Rooms",
            "Manufacturing Plants",
            "Commercial Complexes",
            "Oil & Gas Infrastructure",
            "Telecom and Data Centers"
        ],
        advantages: [
            "Enhances functionality and flexibility of cable tray systems",
            "Easy to install and integrate with existing trays",
            "Improves aesthetics and organization of cabling",
            "Reduces labor time during tray installation",
            "Minimizes cable strain and sagging at turns or transitions",
            "Durable construction ensures long-term reliability",
            "Cost-effective solution for structured cabling"
        ]
    }
}
,
    {
    id: 25,
    image: img24,
    icon: icon2,
    simage: simg2,
    title: 'Raceway Ducts Trucking',
    description: 'Raceway Ducts Trucking systems are enclosed channels designed to route and protect electrical wires and cables in commercial, industrial, and residential installations. They ensure organized cabling, prevent physical damage, and enhance the safety and appearance of electrical infrastructure.',
    slug: 'raceway-ducts-trucking',
    leftFeatures: [
        "Protects wires and cables from external impact, dust, and moisture.",
        "Provides a clean and organized cable management system.",
        "Supports surface and concealed wiring applications.",
        "Eases troubleshooting and cable modifications.",
        "Prevents unauthorized access to electrical wiring."
    ],
    rightFeatures: [
        "Available in different sizes and finishes (PVC, GI, Aluminum).",
        "Corrosion-resistant and flame-retardant options available.",
        "Smooth internal surface for easy cable pulling.",
        "Snap-on and lockable cover options.",
        "Can be mounted on walls, ceilings, or floors."
    ],
    specificationsData: {
        specifications: [
            "Material: GI / PVC / Aluminum",
            "Finish: Powder Coated / Galvanized / Painted",
            "Sizes: Width from 25mm to 300mm; Height from 25mm to 100mm",
            "Length: Typically 2.5m or customized",
            "Type: Solid / Slotted / Partitioned",
            "Mounting: Surface / Recessed / Wall-mounted"
        ],
        applications: [
            "Commercial and Residential Buildings",
            "IT Server Rooms and Data Centers",
            "Control Panels and Electrical Rooms",
            "Hospitals and Clean Rooms",
            "Manufacturing Units and Plants",
            "Educational Institutions",
            "Retail Stores and Malls"
        ],
        advantages: [
            "Improves cable routing and aesthetics",
            "Reduces electromagnetic interference risks",
            "Safe enclosure prevents electrical hazards",
            "Quick and hassle-free installation",
            "Enables future cable additions or modifications",
            "Durable and long-lasting performance",
            "Available in multiple variants to suit all environments"
        ]
    }
}
,
    {
    id: 26,
    image: img24,
    icon: icon2,
    simage: simg2,
    title: 'Petroleum Production',
    description: 'Petroleum production involves the extraction, processing, and transportation of crude oil and natural gas. It includes advanced techniques and equipment to ensure safe, efficient, and sustainable recovery of hydrocarbons for energy and industrial applications.',
    slug: 'petroleum-production-2',
    leftFeatures: [
        "Utilizes advanced drilling and extraction technologies.",
        "Supports both onshore and offshore operations.",
        "Includes well logging, casing, and cementing processes.",
        "Designed for high-pressure and high-temperature environments.",
        "Reduces environmental impact through emission control systems."
    ],
    rightFeatures: [
        "Integrated safety and monitoring systems.",
        "Automated controls improve operational efficiency.",
        "Corrosion-resistant materials ensure long equipment life.",
        "Adaptable to different geological formations.",
        "Complies with international safety and environmental standards."
    ],
    specificationsData: {
        specifications: [
            "Extraction Methods: Primary, Secondary, Enhanced Recovery",
            "Drilling Types: Vertical, Directional, Horizontal",
            "Equipment: Pumps, Separators, Heat Exchangers, Compressors",
            "Material: High-grade steel and corrosion-resistant alloys",
            "Monitoring: SCADA, sensors, remote surveillance",
            "Compliance: API, ISO, OHSAS, and environmental norms"
        ],
        applications: [
            "Crude Oil and Gas Extraction",
            "Refineries and Petrochemical Plants",
            "Power Generation Facilities",
            "Industrial Heating Systems",
            "Offshore and Onshore Drilling Platforms",
            "Pipeline Transportation and Storage",
            "Fuel Distribution Networks"
        ],
        advantages: [
            "High energy output and global energy supply backbone",
            "Employs scalable and modular systems",
            "Advanced safety and environmental protection features",
            "Automation reduces labor and human error",
            "Long operational lifespan of infrastructure",
            "Supports global economic and industrial growth",
            "Continuous innovation in extraction and processing"
        ]
    }
}
,
    
    
];

export default Services;